import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col, InputGroup, Alert } from 'react-bootstrap';
import { BiWrench, BiHash, BiRefresh } from 'react-icons/bi';
import { toast } from 'react-toastify';

const BulkSerialGenerator = ({ show, onHide, onGenerate, itemName }) => {
    const [config, setConfig] = useState({
        prefix: (itemName || "").substring(0, 3).toUpperCase() + "-",
        startNumber: 1,
        quantity: 1,
        padding: 4
    });

    const [preview, setPreview] = useState([]);

    const handleUpdate = (field, value) => {
        const newConfig = { ...config, [field]: value };
        setConfig(newConfig);
        generatePreview(newConfig);
    };

    const generatePreview = (cfg) => {
        const { prefix, startNumber, quantity, padding } = cfg;
        const results = [];
        const limit = Math.min(quantity, 5); // Show only first 5 in preview
        for (let i = 0; i < limit; i++) {
            const num = (parseInt(startNumber) + i).toString().padStart(padding, '0');
            results.push(`${prefix}${num}`);
        }
        setPreview(results);
    };

    const handleGenerate = () => {
        if (config.quantity < 1) return toast.error("Quantity must be at least 1");
        if (config.quantity > 500) return toast.error("Max 500 serials at once for stability");

        onGenerate(config);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className="bg-dark text-white">
                <Modal.Title className="h6 fw-bold text-uppercase">
                    <BiRefresh className="me-2" /> Bulk Serial Generator
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <Alert variant="info" className="x-small py-2 border-0">
                    Generating for: <strong>{itemName}</strong>
                </Alert>

                <Row className="g-3">
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="x-small fw-bold text-muted uppercase">Prefix</Form.Label>
                            <Form.Control
                                size="sm"
                                value={config.prefix}
                                onChange={(e) => handleUpdate('prefix', e.target.value)}
                                className="fw-bold border-dark"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="x-small fw-bold text-muted uppercase">Start Number</Form.Label>
                            <Form.Control
                                type="number"
                                size="sm"
                                value={config.startNumber}
                                onChange={(e) => handleUpdate('startNumber', parseInt(e.target.value) || 0)}
                                className="fw-bold border-dark"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="x-small fw-bold text-muted uppercase">Quantity</Form.Label>
                            <Form.Control
                                type="number"
                                size="sm"
                                value={config.quantity}
                                onChange={(e) => handleUpdate('quantity', parseInt(e.target.value) || 0)}
                                className="fw-bold border-dark"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label className="x-small fw-bold text-muted uppercase">Padding Size</Form.Label>
                            <Form.Control
                                type="number"
                                size="sm"
                                value={config.padding}
                                onChange={(e) => handleUpdate('padding', parseInt(e.target.value) || 0)}
                                className="fw-bold border-dark"
                            />
                        </Form.Group>
                    </Col>
                </Row>

                {preview.length > 0 && (
                    <div className="mt-4 p-3 bg-light rounded border border-dashed">
                        <label className="x-small fw-bold text-muted uppercase mb-2">Preview</label>
                        <div className="d-flex flex-wrap gap-1">
                            {preview.map((p, i) => (
                                <span key={i} className="badge bg-white border text-dark font-monospace x-small">
                                    {p}
                                </span>
                            ))}
                            {config.quantity > 5 && <span className="text-muted x-small">... {config.quantity - 5} more</span>}
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className="border-0 p-3">
                <Button variant="light" size="sm" onClick={onHide} className="fw-bold">CANCEL</Button>
                <Button
                    variant="dark"
                    size="sm"
                    onClick={handleGenerate}
                    className="fw-bold px-4"
                    style={{ backgroundColor: '#001c3a' }}
                >
                    GENERATE & MERGE
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BulkSerialGenerator;
